import { render, staticRenderFns } from "./businessScope.vue?vue&type=template&id=2b8a1ae4&scoped=true"
import script from "./businessScope.vue?vue&type=script&lang=js"
export * from "./businessScope.vue?vue&type=script&lang=js"
import style0 from "./businessScope.vue?vue&type=style&index=0&id=2b8a1ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8a1ae4",
  null
  
)

export default component.exports